export interface SubCategoryProps {
  id: string;
  name: string;
  slug: string;
  description?: string | null;
  imageId?: string | null;
  imageUrl?: string | null;
  status?: boolean | string;
  displayOrder?: number;
  categoryId: string;
  categoryName?: string | null;
  createdAt?: string;
  updatedAt?: string;
  image?: {
    id: string;
    url: string;
    fileName: string;
    altText?: string | null;
  } | null;
  category?: {
    id: string;
    name: string;
    slug: string;
  } | null;
}

export class SubCategoryEntity {
  constructor(private readonly props: SubCategoryProps) {
    if (!props.id) throw new Error('El ID de la subcategoría es obligatorio');
    if (!props.name) throw new Error('El nombre de la subcategoría es obligatorio');
    if (!props.slug) throw new Error('El slug de la subcategoría es obligatorio');
    if (!props.categoryId) throw new Error('La categoría padre (categoryId) es obligatoria');
  }

  get id(): string {
    return this.props.id;
  }

  get name(): string {
    return this.props.name;
  }

  get slug(): string {
    return this.props.slug;
  }

  get description(): string {
    return this.props.description ?? '';
  }

  get imageId(): string | null {
    return this.props.imageId ?? null;
  }

  get imageUrl(): string | null {
    return this.props.imageUrl ?? this.props.image?.url ?? null;
  }

  get status(): boolean {
    if (typeof this.props.status === 'boolean') return this.props.status;
    return this.props.status !== 'inactive';
  }

  get isActive(): boolean {
    return this.status;
  }

  get displayOrder(): number {
    return this.props.displayOrder ?? 0;
  }

  get categoryId(): string {
    return this.props.categoryId;
  }

  get categoryName(): string | null {
    return this.props.categoryName ?? this.props.category?.name ?? null;
  }

  get createdAt(): string | undefined {
    return this.props.createdAt;
  }

  get updatedAt(): string | undefined {
    return this.props.updatedAt;
  }

  toJSON(): SubCategoryProps {
    return { ...this.props };
  }
}
